module.exports = __webpack_public_path__ + "static/cambion-350b4cbd714712037ad79a59f126799e.jpg";